class Departments {
  static names = {
    [Departments.getMenInternalName()]: 'Men',
    [Departments.getWomenInternalName()]: 'Women',
    [Departments.getKidsInternalName()]: 'Kids',
    [Departments.getBabyGirlsInternalName()]: 'Baby Girls',
    [Departments.getBabyBoysInternalName()]: 'Baby Boys',
    [Departments.getBabyUnisexInternalName()]: 'Kids',
    [Departments.getGirlsInternalName()]: 'Girls',
    [Departments.getBoysInternalName()]: 'Boys',
    [Departments.getHomeInternalName()]: 'Home',
  };

  static ids = {
    [Departments.getMenInternalName()]: '1',
    [Departments.getWomenInternalName()]: '2',
    [Departments.getKidsInternalName()]: '11',
    [Departments.getBabyGirlsInternalName()]: '5',
    [Departments.getBabyBoysInternalName()]: '6',
    [Departments.getBabyUnisexInternalName()]: '7',
    [Departments.getGirlsInternalName()]: '8',
    [Departments.getBoysInternalName()]: '9',
    [Departments.getHomeInternalName()]: '12',
  };

  static defaultUnisexMap = {
    [Departments.getUnisexInternalName()]: Departments.getWomenInternalName(),
    [Departments.getBabyUnisexInternalName()]: Departments.getBabyGirlsInternalName(),
    [Departments.getKidsUnisexInternalName()]: Departments.getGirlsInternalName(),
  };

  static namesCategoryNonDescriptiveSeo = {
    [Departments.getMenInternalName()]: 'Men',
    [Departments.getWomenInternalName()]: 'Women',
    [Departments.getKidsInternalName()]: 'Kids',
    [Departments.getBabyUnisexInternalName()]: 'Kids',
  };

  static possessiveNouns = {
    [Departments.getMenInternalName()]: "Men's",
    [Departments.getWomenInternalName()]: "Women's",
    [Departments.getKidsInternalName()]: "Kids'",
    [Departments.getBabyGirlsInternalName()]: "Baby Girls'",
    [Departments.getBabyBoysInternalName()]: "Baby Boys'",
    [Departments.getBabyUnisexInternalName()]: "Kids'",
    [Departments.getGirlsInternalName()]: "Girls'",
    [Departments.getBoysInternalName()]: "Boys'",
    [Departments.getHomeInternalName()]: 'Home',
  };

  static oppositeDepartments = {
    [Departments.getWomenInternalName()]: Departments.getMenInternalName(),
    [Departments.getMenInternalName()]: Departments.getWomenInternalName(),
  };

  static getMenInternalName(): string {
    return 'men';
  }

  static getWomenInternalName(): string {
    return 'women';
  }

  static getHomeInternalName(): string {
    return 'home';
  }

  static getUnisexInternalName(): string {
    return 'unisex';
  }

  static getKidsInternalName(): string {
    return 'kids';
  }

  static getKidsUnisexInternalName(): string {
    return 'kids-unisex';
  }

  static getBabyGirlsInternalName(): string {
    return 'baby-girls';
  }

  static getBabyBoysInternalName(): string {
    return 'baby-boys';
  }

  static getBabyUnisexInternalName(): string {
    return 'baby-unisex';
  }

  static getGirlsInternalName(): string {
    return 'girls';
  }

  static getBoysInternalName(): string {
    return 'boys';
  }

  static getKidsSingularNames(): string[] {
    return ['boy', 'girl', 'baby-boy', 'baby-girl'];
  }

  static getKidsDepartmentsInternalNames(): string[] {
    return [
      Departments.getKidsInternalName(),
      Departments.getKidsUnisexInternalName(),
      Departments.getBabyBoysInternalName(),
      Departments.getBabyGirlsInternalName(),
      Departments.getBabyUnisexInternalName(),
      Departments.getBoysInternalName(),
      Departments.getGirlsInternalName(),
      ...Departments.getKidsSingularNames(),
    ];
  }

  static getBabyKidsDepartmentsInternalNames(): string[] {
    return [
      Departments.getBabyGirlsInternalName(),
      Departments.getBabyBoysInternalName(),
      Departments.getBabyUnisexInternalName(),
    ];
  }

  static getJuniorKidsDepartmentsInternalNames(): string[] {
    return Departments.getKidsDepartmentsInternalNames().filter(
      department => !Departments.getBabyKidsDepartmentsInternalNames().includes(department),
    );
  }

  static getKidsSubDepartmentsNames(): string[] {
    return [
      Departments.getBabyGirlsName(),
      Departments.getBabyBoysName(),
      Departments.getBoysName(),
      Departments.getGirlsName(),
    ];
  }

  static getAdultsDepartmentsInternalNames(): string[] {
    return [Departments.getWomenInternalName(), Departments.getMenInternalName()];
  }

  static getInternalName(department): string {
    if (Departments.getKidsDepartmentsInternalNames().includes(department)) {
      return Departments.getKidsInternalName();
    }

    return department;
  }

  static getWomenName(): string {
    return this.names[Departments.getWomenInternalName()];
  }

  static getMenName(): string {
    return this.names[Departments.getMenInternalName()];
  }

  static getKidsName(): string {
    return this.names[Departments.getKidsInternalName()];
  }

  static getBabyGirlsName(): string {
    return this.names[Departments.getBabyGirlsInternalName()];
  }

  static getBabyBoysName(): string {
    return this.names[Departments.getBabyBoysInternalName()];
  }

  static getGirlsName(): string {
    return this.names[Departments.getGirlsInternalName()];
  }

  static getBoysName(): string {
    return this.names[Departments.getBoysInternalName()];
  }

  static getHomeName(): string {
    return this.names[Departments.getHomeInternalName()];
  }

  static getHomeId() {
    return this.ids[this.getHomeInternalName()];
  }

  static getWomenSynonyms(): string[] {
    const names = [Departments.getWomenName(), 'Woman'];
    return [...names, ...names.map(el => el.toLowerCase())];
  }

  static getMenSynonyms(): string[] {
    const names = [Departments.getMenName(), 'Man'];
    return [...names, ...names.map(el => el.toLowerCase())];
  }

  static getKidsSynonyms(): string[] {
    const names = [Departments.getKidsName(), 'Kid'];
    return [...names, ...names.map(el => el.toLowerCase())];
  }

  static getAllowedDepartmentNames(): string[] {
    return [...Departments.getWomenSynonyms(), ...Departments.getMenSynonyms(), ...Departments.getKidsSynonyms()];
  }

  static getOppositeDepartment(department): string {
    return this.oppositeDepartments[department];
  }

  static getName(department): string {
    return this.names[department];
  }

  static findInternalName(name): string {
    return Object.keys(this.names).find(internalName => this.names[internalName] === name);
  }

  static getNameAsPossessiveNoun(department): string {
    return this.possessiveNouns[department];
  }

  static getDepartmentId(internalName: string): string {
    return this.ids[internalName];
  }

  static isUnisexDepartment(internalName: string): boolean {
    return internalName in this.defaultUnisexMap;
  }

  static getNonUnisexDepartment(internalName: string): string {
    if (this.isUnisexDepartment(internalName)) {
      return this.defaultUnisexMap[internalName];
    }
    return internalName;
  }

  static getUserFacingDepartment(
    navigationDepartmentInternalName: string,
    productDepartmentInternalName: string,
  ): string {
    if (!this.isUnisexDepartment(productDepartmentInternalName)) {
      return productDepartmentInternalName;
    }

    const defaultValue = this.getNonUnisexDepartment(navigationDepartmentInternalName);

    if (defaultValue === Departments.getKidsInternalName()) {
      // if the navigation is on kids page
      return Departments.getNonUnisexDepartment(productDepartmentInternalName);
    }

    return defaultValue; // otherwise return the navigation internal name
  }

  static filterBrandDepartmentTitle = (brand: string, departmentName: string, infix = ''): string => {
    const kidsSynonyms = ['kid', 'kids', 'baby', 'babies', 'child', 'children'];
    if (
      departmentName === Departments.getKidsName() &&
      kidsSynonyms.some(synonym => brand.toLowerCase().includes(synonym))
    ) {
      return brand;
    }
    return `${brand}${infix} for ${departmentName}`;
  };
}

export default Departments;
